export default __webpack_public_path__ + "static/media/forest_beehive.bfef3787.svg";